export default [
  { id: 1, name: 'characteristic' },
  { id: 2, name: 'communicationtype' },
  // { id: 3, name: 'density' },
  { id: 4, name: 'unit' },
  { id: 5, name: 'city' },
  { id: 6, name: 'region' },
]
